// src/components/common/ErrorBlock.jsx
import React from 'react'
import Button from './Button.jsx'

export default function ErrorBlock({
    title = "Something went wrong",
    message = "We're sorry, but something went wrong. Please try again.",
    onRetry,
    className = ""
}) {
    return (
        <div className={`bg-black-50 border border-gray-700 rounded-lg p-6 ${className}`}>
            <div className="flex">

                <div className="ml-3 flex-1">
                    <h3 className="text-sm font-medium text-red-900">{title}</h3>
                    <div className="mt-2 text-sm text-red-900">
                        <p>{message}</p>
                    </div>
                    {onRetry && (
                        <div className="mt-4">
                            <Button
                                variant="transparent"
                                className='text-gray-400'
                                size="small"
                                onClick={onRetry}
                            >
                                Try Again
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}